export default {"src":"/_next/static/media/humidity.c6d0bb5e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};